import { useHistory, useLocation, useParams } from "react-router-dom"

import * as queryString from "query-string"
import { useCallback } from "react"

export const useReglasConciliacionPage = () => {
  const { nifTitular } = useParams<{ nifTitular: string }>()
  const history = useHistory()
  const location = useLocation()

  const currentQueryParams = queryString.parse(location.search)

  const tipoParam = currentQueryParams.tipo
  const initialTipo: number | undefined =
    typeof tipoParam === "string" ? parseInt(tipoParam, 10) : undefined

  const handleUpdateTipoParam = (tipo: number): void => {
    const newQueryParams = {
      ...currentQueryParams,
      tipo,
    }
    history.push({
      search: queryString.stringify(newQueryParams),
    })
  }

  const handleUpdateCuentaIdParam = (cuentaId: string): void => {
    const newQueryParams = {
      ...currentQueryParams,
      cuentaId,
    }
    history.push({
      search: queryString.stringify(newQueryParams),
    })
  }
  const handleNavigateToForm = useCallback(
    ({
      id,
      tipo,
      iban,
      cuentaId,
    }: {
      id?: string
      tipo: string
      iban: string
      cuentaId: string
    }) => {
      history.push({
        pathname: `/tesoreria/reglas-conciliacion/regla${
          id ? `/${id}` : "/crear"
        }`,
        search: `?tipo=${tipo}&iban=${iban}&cuentaId=${cuentaId}`,
      })
    },
    [history]
  )

  const handleBack = useCallback(() => {
    history.push({
      pathname: "/tesoreria/bancos",
    })
  }, [history])
  return {
    initialTipo,
    handleUpdateTipoParam,
    handleUpdateCuentaIdParam,
    handleNavigateToForm,
    nifTitular,
    handleBack,
  }
}
